import React from 'react';
import FormHelperText from '@mui/material/FormHelperText';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import DeleteOutlined from '@mui/icons-material/DeleteOutlined';
import type { CustomParam } from '../buildTestLink';

interface Props {
  index: number;
  param: CustomParam;
  ignored: boolean;
  onChange: (param: CustomParam) => void;
  onRemove: () => void;
}

const CustomParamRow: React.FC<Props> = ({ index, param, ignored, onChange, onRemove }) => (
  <div>
    <Stack direction='row' spacing={1} sx={{ alignItems: 'center' }}>
      <TextField
        size='small'
        placeholder='name'
        value={param.key}
        error={ignored}
        slotProps={{ htmlInput: { 'aria-label': `Param ${index + 1} name`, spellCheck: false } }}
        onChange={(e) => onChange({ ...param, key: e.target.value })}
        sx={{ flex: 1 }}
      />
      <TextField
        size='small'
        placeholder='value'
        value={param.value}
        slotProps={{ htmlInput: { 'aria-label': `Param ${index + 1} value`, spellCheck: false } }}
        onChange={(e) => onChange({ ...param, value: e.target.value })}
        sx={{ flex: 1.4 }}
      />
      <IconButton aria-label={`Remove param ${index + 1}`} onClick={onRemove}>
        <DeleteOutlined />
      </IconButton>
    </Stack>
    {ignored && <FormHelperText error>Already set — ignored.</FormHelperText>}
  </div>
);

export default CustomParamRow;
